import { z } from 'zod';
import { CncJobStatus } from '../enums';

export const CncJobStatusSchema = z.nativeEnum(CncJobStatus);

export const CncJobSchema = z.object({
  id: z.string().uuid(),
  project_id: z.string().uuid(),
  area_ids: z.array(z.string().uuid()).default([]),
  phase: z.string(),
  cnc_machine: z.string(),
  material_tags: z.array(z.string()),
  status: CncJobStatusSchema,
  sort_order: z.number().int(),
  notes: z.string().nullable(),
  created_at: z.string().datetime(),
  updated_at: z.string().datetime(),
});

export const CreateCncJobSchema = z.object({
  project_id: z.string().uuid({ message: 'Project is required' }),
  area_ids: z.array(z.string().uuid()).default([]),
  phase: z.string().min(1, 'Phase is required'),
  cnc_machine: z.string().min(1, 'CNC machine is required'),
  material_tags: z.array(z.string()).default([]),
  status: CncJobStatusSchema.default(CncJobStatus.INCOMING_CUTS),
  notes: z.string().nullable().optional(),
});

export const UpdateCncJobSchema = CreateCncJobSchema.partial();

export const MoveCncJobSchema = z.object({
  status: CncJobStatusSchema,
  sortOrder: z.number().int(),
});

export type CncJob = z.infer<typeof CncJobSchema>;
export type CreateCncJob = z.infer<typeof CreateCncJobSchema>;
export type UpdateCncJob = z.infer<typeof UpdateCncJobSchema>;
export type MoveCncJob = z.infer<typeof MoveCncJobSchema>;
